/**
 * The tasks section: two routes and nothing else.
 *
 * This file used to be the whole section - a kanban, a detail screen and a
 * create dialog in one 321-line file, all of it drawn with the pre-redesign
 * `@wa/ui` components. Everything now lives in a file named after what it does
 * (AGENTS.md §4); the entry point kept its name so no caller had to move
 * (`CrmLayout` looks the section up by this import).
 *
 * - `TasksList`     the register and the board over it
 * - `TaskBoard`     the four status columns
 * - `TaskDetail`    one task, its time and its comments
 * - `TaskRowMenu`   the actions at the end of a row or on a card
 * - `NewTaskModal`  the create dialog
 * - `priority.ts`   priority as the design's tones
 */
import { Route, Routes } from "react-router-dom";
import type { StaffUser } from "../../../lib/auth";
import { TaskDetail } from "./TaskDetail";
import { TasksList } from "./TasksList";

// The whole section already answers to `manage:crm.projects` in `crm/nav.ts`,
// so anybody who can reach these routes can also write to them. Nothing here
// gates a second time on the same right.
export function TasksSection({ user: _user }: { user: StaffUser }) {
  return (
    <Routes>
      <Route path="/" element={<TasksList />} />
      <Route path="/:id" element={<TaskDetail />} />
    </Routes>
  );
}
